// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"FilterSidebar_checkbox__29OUC","ant-checkbox":"FilterSidebar_ant-checkbox__1m6t6"};